export default __webpack_public_path__ + "static/media/DanceTeacher.6b38208e.jpg";